import { useQuery } from '@tanstack/react-query';
import { axiosGetV3 } from '../../api/axios-handler';
import { PackageDetailsResponse } from './useClientCode';

const getClientDefaultPackage = async (clientId: number): Promise<PackageDetailsResponse> => {
  return await axiosGetV3(`/clients/${clientId}/default_package_details`, {}).then((response) => response.data);
};

export const useClientDefaultPackage = (clientId?: number) =>
  useQuery<PackageDetailsResponse>(['clientDefaultPackage', clientId], () => getClientDefaultPackage(clientId!), {
    enabled: typeof clientId === 'number' && !Number.isNaN(clientId),
    retry: 1,
    staleTime: Infinity,
  });
